import { render, staticRenderFns } from "./addMannger.vue?vue&type=template&id=7b32d855&scoped=true"
import script from "./addMannger.vue?vue&type=script&lang=js"
export * from "./addMannger.vue?vue&type=script&lang=js"
import style0 from "./addMannger.vue?vue&type=style&index=0&id=7b32d855&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b32d855",
  null
  
)

export default component.exports